import { API_ROUTE } from "../../../utils/constants.js";
import { baseApi } from "../baseApi.js";
import { getToken } from "../localStorageService.js";

export const patientApi = baseApi.injectEndpoints({
  credentials: "include",
  endpoints: (builder) => ({
    addpatient: builder.mutation({
      query: (user) => {
        return {
          url: API_ROUTE.addPatient,
          method: "POST",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    getpatients: builder.query({
      query: ({ search, limit, page, user_role = "client", client_id }) => {
        let query = `${API_ROUTE.getStaffs}/${user_role}/get-patient?search=${search}&limit=${limit}&page=${page}`
        if (client_id) {
          query += `&client_id=${client_id}`
        }
        return {
          url: query,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
    }),
    updatepatient: builder.mutation({
      query: (user) => {
        return {
          url: `${API_ROUTE.updatPatient}/${user.id}`,
          method: "PATCH",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: getToken(),
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    deletepatient: builder.mutation({
      query: (user) => {
        return {
          url: `${API_ROUTE.deletePatient}/${user.id}`,
          method: "DELETE",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
    }),
    getExportCSV: builder.query({
      query: ({user_role = "client",}) => {
        return {
          url: `${API_ROUTE.export_CSV}/${user_role}/patients/export-csv`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
    }),
  }),
});

export const {
  useAddpatientMutation,
  useGetpatientsQuery,
  useUpdatepatientMutation,
  useDeletepatientMutation,
  useGetExportCSVQuery,
} = patientApi;
